/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectAppraisalResource
 */
export interface ProjectAppraisalResource {
    /**
     * 
     * @type {number}
     * @memberof ProjectAppraisalResource
     */
    rating?: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectAppraisalResource
     */
    comment?: string;
}

/**
 * Check if a given object implements the ProjectAppraisalResource interface.
 */
export function instanceOfProjectAppraisalResource(value: object): value is ProjectAppraisalResource {
    return true;
}

export function ProjectAppraisalResourceFromJSON(json: any): ProjectAppraisalResource {
    return ProjectAppraisalResourceFromJSONTyped(json, false);
}

export function ProjectAppraisalResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectAppraisalResource {
    if (json == null) {
        return json;
    }
    return {
        
        'rating': json['rating'] == null ? undefined : json['rating'],
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function ProjectAppraisalResourceToJSON(value?: ProjectAppraisalResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'rating': value['rating'],
        'comment': value['comment'],
    };
}

